import React from "react";
import { observer } from "mobx-react";
import { MusicalWorkCreateStore } from "../../store";
import { MusicalWorkCreateForm } from "./MusicalWorkCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type MusicalWorkCreateProps = {
  musicalWorkCreateStore: MusicalWorkCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const MusicalWorkCreate: React.FC<MusicalWorkCreateProps> = observer(
  ({ musicalWorkCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={musicalWorkCreateStore.isSaving} />
        <MusicalWorkCreateForm
          musicalWorkCreateStore={musicalWorkCreateStore}
          titleError={musicalWorkCreateStore.errors.title?.message}
          onTitleChange={(value: string) => {
            musicalWorkCreateStore.setTitleValue(value);
          }}
          title={musicalWorkCreateStore.entityValues.title}
          musicalGenreError={
            musicalWorkCreateStore.errors.musicalGenre?.message
          }
          onMusicalGenreChange={(value) => {
            musicalWorkCreateStore.setMusicalGenreValue(value);
          }}
          musicalGenreSelectedValue={
            musicalWorkCreateStore.entityValues.showMusicalGenre
          }
          onMusicalGenreSelected={(value) => {
            musicalWorkCreateStore.setSelectedMusicalGenre(value);
          }}
          musicalGenreOptions={musicalWorkCreateStore.getMusicalGenreOptions()}
          alternativeTitlesError={
            musicalWorkCreateStore.errors.alternativeTitles?.message
          }
          onAlternativeTitlesChange={(value: string[]) => {
            musicalWorkCreateStore.setAlternativeTitlesValue(value);
          }}
          alternativeTitles={
            musicalWorkCreateStore.entityValues.alternativeTitles
          }
          workAuthorCreateStore={musicalWorkCreateStore.authorsCreateStore}
          authorsVisibleColumns={musicalWorkCreateStore.authorsVisibleColumns}
          authorsOnRestore={(id: string) =>
            musicalWorkCreateStore.authorsRestore(id)
          }
          authorsOnCommitChanges={(changes) =>
            musicalWorkCreateStore.authorsCommitChanges(changes)
          }
          authorsValidateChanges={(changes) =>
            musicalWorkCreateStore.authorsValidateChanges(changes)
          }
          authorsRows={musicalWorkCreateStore.entityValues.showAuthors}
          authorsError={musicalWorkCreateStore.errors.authors?.message}
          notesError={musicalWorkCreateStore.errors.notes?.message}
          onNotesChange={(value: string) => {
            musicalWorkCreateStore.setNotesValue(value);
          }}
          notes={musicalWorkCreateStore.entityValues.notes}
          performersError={musicalWorkCreateStore.errors.performers?.message}
          onPerformersChange={(value) => {
            musicalWorkCreateStore.setPerformersValue(value);
          }}
          performersSelectedValues={
            musicalWorkCreateStore.entityValues.showPerformers
          }
          onPerformersSelected={(value) => {
            musicalWorkCreateStore.setSelectedPerformers(value);
          }}
          performersOptions={musicalWorkCreateStore.getPerformersOptions()}
          cmsIdError={musicalWorkCreateStore.errors.cmsId?.message}
          onCmsIdChange={(value: string) => {
            musicalWorkCreateStore.setCmsIdValue(value);
          }}
          cmsId={musicalWorkCreateStore.entityValues.cmsId}
          territoriesError={musicalWorkCreateStore.errors.territories?.message}
          onTerritoriesChange={(value) => {
            musicalWorkCreateStore.setTerritoriesValue(value);
          }}
          territoriesSelectedValues={
            musicalWorkCreateStore.entityValues.showTerritories
          }
          onTerritoriesSelected={(value) => {
            musicalWorkCreateStore.setSelectedTerritories(value);
          }}
          territoriesOptions={musicalWorkCreateStore.getTerritoriesOptions()}
          iswcError={musicalWorkCreateStore.errors.iswc?.message}
          onIswcChange={(value: string) => {
            musicalWorkCreateStore.setIswcValue(value);
          }}
          iswc={musicalWorkCreateStore.entityValues.iswc}
          scoreOnRestoreFile={(id: string) =>
            musicalWorkCreateStore.scoreRestoreFile(id)
          }
          scoreOnLoadFile={(file: any) =>
            musicalWorkCreateStore.scoreUploadFile(file)
          }
          scoreOnCommitFile={(changes) =>
            musicalWorkCreateStore.scoreCommitFile(changes)
          }
          scoreFiles={musicalWorkCreateStore.entityValues.__score_files}
          scoreError={musicalWorkCreateStore.errors.score?.message}
          phonogramCreateStore={musicalWorkCreateStore.phonogramsCreateStore}
          phonogramsVisibleColumns={
            musicalWorkCreateStore.phonogramsVisibleColumns
          }
          phonogramsOnRestore={(id: string) =>
            musicalWorkCreateStore.phonogramsRestore(id)
          }
          phonogramsOnCommitChanges={(changes) =>
            musicalWorkCreateStore.phonogramsCommitChanges(changes)
          }
          phonogramsValidateChanges={(changes) =>
            musicalWorkCreateStore.phonogramsValidateChanges(changes)
          }
          phonogramsRows={musicalWorkCreateStore.entityValues.showPhonograms}
          phonogramsError={musicalWorkCreateStore.errors.phonograms?.message}
          originalLyricsError={
            musicalWorkCreateStore.errors.originalLyrics?.message
          }
          onOriginalLyricsChange={(value: string) => {
            musicalWorkCreateStore.setOriginalLyricsValue(value);
          }}
          originalLyrics={musicalWorkCreateStore.entityValues.originalLyrics}
          contractObservationError={
            musicalWorkCreateStore.errors.contractObservation?.message
          }
          onContractObservationChange={(value: string) => {
            musicalWorkCreateStore.setContractObservationValue(value);
          }}
          contractObservation={
            musicalWorkCreateStore.entityValues.contractObservation
          }
          dummyCRUDRestoredObservable={
            musicalWorkCreateStore.dummyCRUDRestoredObservable
          }
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={musicalWorkCreateStore.isProcessing}
          onSave={() => musicalWorkCreateStore.saveNewMusicalWork()}
          onCancel={() => musicalWorkCreateStore.cancelNewMusicalWork()}
        />
        <ErrorDialog
          open={musicalWorkCreateStore.errorDialogOpened}
          title={musicalWorkCreateStore.errorTitle}
          description={musicalWorkCreateStore.errorDescription}
          onClose={() => musicalWorkCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
